<!--
 * @Auther: 罗耀祖
 * @Date: 2022-05-24 17:24:59
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-27 10:24:27
 * @name: 海伦易购APP下载
 * @Description: 海伦易购APP下载
 * @FilePath: \preSaleNafterSaleBackstage\src\views\preSaleNafterSaleDistributorApp.vue
 * @Author: desktop
-->
<template>
  <div class="preSaleNafterSaleDistributorApp">
    <mv-full-page
      :isPointer="false"
      pointerPos="right"
      :isV="isV"
      :pages="3"
      :page.sync="currentPage"
      :isCache="true"
      :transition="{
        duration: '700ms', // 动画时长
        timingFun: 'ease', // 动画速度曲线
        delay: '0s', // 动画延迟
      }"
    >
      <template #page1>
        <div class="page1">
          <img
            class="page1-bc"
            src="@/assets/preSaleNafterSaleDistributorApp/page1-bc.png"
          />
          <img
            :style="page1FlagStyle"
            src="@/assets/preSaleNafterSaleDistributorApp/page1-flag.png"
          />
          <img
            :style="page1FavStyle"
            src="@/assets/preSaleNafterSaleDistributorApp/page1-fav.png"
          />
          <span :style="page1FontStyle">海伦易购</span>
          <img
            :style="page1MainStyle"
            src="@/assets/preSaleNafterSaleDistributorApp/page1-main.jpg"
          />
          <div :style="page1BtnsStyle">
            <div :style="page1BtnStyle" @click="openApp">打开APP</div>
            <div :style="page1BtnStyle" @click="downLoadApp">下载APP</div>
          </div>
        </div>
      </template>
      <template #page2>
        <div class="page2">
          <img
            class="page2-bc"
            src="@/assets/preSaleNafterSaleDistributorApp/page2-bc.png"
          />
          <span :style="page2TitleStyle">简单管理业务处理</span>
          <div :style="page2LineStyle"></div>
          <span :style="page2FontStyle"
            >售前售后模块分化，高效发起业务需求</span
          >
          <img
            :style="page2MainStyle"
            src="@/assets/preSaleNafterSaleDistributorApp/page2-main.png"
          />
          <div :style="page2BtnStyle" @click="downLoadApp">
            点击下载海伦易购APP
          </div>
        </div>
      </template>
      <template #page3>
        <div class="page3">
          <img
            class="page3-bc"
            src="@/assets/preSaleNafterSaleDistributorApp/page3-bc.png"
          />
          <span :style="page3TitleStyle">工单处理进度把控</span>
          <div :style="page3LineStyle"></div>
          <span :style="page3FontStyle"
            >实时掌握处理进度，有效跟踪每个环节</span
          >
          <img
            :style="page3MainStyle"
            src="@/assets/preSaleNafterSaleDistributorApp/page3-main.png"
          />
          <div :style="page3BtnStyle" @click="downLoadApp">
            点击下载海伦易购APP
          </div>
        </div>
      </template>
    </mv-full-page>
    <div class="wx-tips" @click="TipsShow = false" v-if="TipsShow">
      <img
        :style="wxTipsStyle"
        src="@/assets/preSaleNafterSaleDistributorApp/wx-tips.png"
      />
    </div>
  </div>
</template>
<script>
import {
  dev_ios_distributor,
  dev_android_distributor,
  prod_ios_distributor,
  prod_android_distributor,
} from "@/config/appDownLoadUrl.config";

const pageWidth = document.body.clientWidth; //页面总宽度
const pageHeight = document.body.clientHeight; //页面总高度
const datumX = pageWidth / 375; //x轴基准
const datumY = pageHeight / 735; //y轴基准
let downLoadUrl = ""; //下载地址
//正式环境
if (process.env.NODE_ENV === "production") {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    downLoadUrl = prod_ios_distributor;
  } else {
    downLoadUrl = prod_android_distributor;
  }
}
// 测试环境，包括stage及develop
else {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    downLoadUrl = dev_ios_distributor;
  } else {
    downLoadUrl = dev_android_distributor;
  }
}
export default {
  name: "preSaleNafterSaleDistributorApp",
  data() {
    return {
      isV: true,
      currentPage: 1,
      TipsShow: false, //展示微信提示
      downLoadUrl,
    };
  },
  computed: {
    page1FlagStyle() {
      let height = 44 * datumY;
      let marginTop = 16 * datumY;
      let marginLeft = 24 * datumY;
      return `height: ${height}px;
              marginTop: ${marginTop}px;
              marginLeft: ${marginLeft}px;`;
    },
    page1FavStyle() {
      let height = 94 * datumY;
      let marginTop = 24 * datumY;
      return `height: ${height}px;
              margin: ${marginTop}px auto 0;`;
    },
    page1FontStyle() {
      let marginTop = 12 * datumY;
      let fontSize = 16 * datumY;
      return `width: 100%;
              text-align: center;
              marginTop: ${marginTop}px;`;
    },
    page1MainStyle() {
      let marginTop = 44 * datumY;
      let height = 408 * datumY;
      return `height: ${height}px;
              margin: ${marginTop}px auto 0;`;
    },
    page1BtnsStyle() {
      let bottom = 40 * datumY;
      let height = 40;
      return `width: 100%;
              z-index:2;
              position: absolute;
              bottom: ${bottom}px;
              height: ${height}px;
              display: flex;
              justify-content: space-around;
              align-items: center;`;
    },
    page1BtnStyle() {
      let width = 160 * datumX;
      let borderRadius = 40;
      return `width: ${width}px;
              z-index: 3;
              border-radius: ${borderRadius}px;
              height: 100%;
              display:flex;
              justify-content: center;
              align-items: center;
              color: white;
              background: #D54342;`;
    },
    page2TitleStyle() {
      let marginTop = 38 * datumY;
      let marginLeft = 36 * datumY;
      let fontSize = 26 * datumY;
      return `margin-top: ${marginTop}px;
              margin-left: ${marginLeft}px;
              font-size: ${fontSize}px;
              color: #D54342;`;
    },
    page2LineStyle() {
      let marginTop = 18 * datumY;
      let marginLeft = 36 * datumY;
      let marginBottom = 16 * datumY;
      let width = 34 * datumX;
      return `margin: ${marginTop}px 0 ${marginBottom}px ${marginLeft}px;
              width: ${width}px;
              height: 2px;
              background: #D54342;`;
    },
    page2FontStyle() {
      let marginLeft = 36 * datumY;
      let fontSize = 14 * datumY;
      return `marginLeft: ${marginLeft}px;
              font-size: ${fontSize}px;
              color: #333333;`;
    },
    page2MainStyle() {
      let marginTop = 54 * datumY;
      let height = 464 * datumY;
      return `height: ${height}px;
              margin: ${marginTop}px auto 0;`;
    },
    page2BtnStyle() {
      let bottom = 40 * datumY;
      let height = 40;
      let width = 332 * datumX;
      return `width: ${width}px;
              z-index:2;
              position: absolute;
              left: calc(50% - (${width}px / 2));
              bottom: ${bottom}px;
              height: ${height}px;
              border-radius: ${height}px;
              display:flex;
              justify-content: center;
              align-items: center;
              color: white;
              background: #D54342;`;
    },
    page3TitleStyle() {
      let marginTop = 38 * datumY;
      let marginLeft = 36 * datumY;
      let fontSize = 26 * datumY;
      return `margin-top: ${marginTop}px;
              margin-left: ${marginLeft}px;
              font-size: ${fontSize}px;
              color: #D54342;`;
    },
    page3LineStyle() {
      let marginTop = 18 * datumY;
      let marginLeft = 36 * datumY;
      let marginBottom = 16 * datumY;
      let width = 34 * datumX;
      return `margin: ${marginTop}px 0 ${marginBottom}px ${marginLeft}px;
              width: ${width}px;
              height: 2px;
              background: #D54342;`;
    },
    page3FontStyle() {
      let marginLeft = 36 * datumY;
      let fontSize = 14 * datumY;
      return `marginLeft: ${marginLeft}px;
              font-size: ${fontSize}px;
              color: #333333;`;
    },
    page3MainStyle() {
      let marginTop = 54 * datumY;
      let height = 464 * datumY;
      return `height: ${height}px;
              margin: ${marginTop}px auto 0;`;
    },
    page3BtnStyle() {
      let bottom = 40 * datumY;
      let height = 40;
      let width = 332 * datumX;
      return `width: ${width}px;
              z-index:2;
              position: absolute;
              left: calc(50% - (${width}px / 2));
              bottom: ${bottom}px;
              height: ${height}px;
              border-radius: ${height}px;
              display:flex;
              justify-content: center;
              align-items: center;
              color: white;
              background: #D54342;`;
    },
    wxTipsStyle() {
      let width = 218 * datumX;
      return `position: absolute;
              top: 0;
              right: 0;
              width: ${width}px`;
    },
  },
  beforeCreate() {
    document.title = "海伦易购APP";
  },
  methods: {
    openApp() {
      const isWeiXin = this.isWeiXin();
      if (!isWeiXin) {
        window.location = "comHailunmusicAgency://";
      }
    },
    downLoadApp() {
      const isWeiXin = this.isWeiXin();
      if (!isWeiXin) {
        window.location = this.downLoadUrl;
      }
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 判断是否是微信内置浏览器
     */
    isWeiXin() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.TipsShow = true;
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.preSaleNafterSaleDistributorApp {
  width: 100%;
  height: 100%;
  position: relative;
  .wx-tips {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }
  .page {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .page1 {
    @extend .page;
    .page1-bc {
      position: absolute;
      width: 100%;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      z-index: -1;
    }
  }
  .page2 {
    @extend .page;
    .page2-bc {
      position: absolute;
      width: 100%;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      z-index: -1;
    }
  }
  .page3 {
    @extend .page;
    .page3-bc {
      position: absolute;
      width: 100%;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      z-index: -1;
    }
  }
}
</style>